import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Factory, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function SectorsPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/catalog/sectors").then((r) => setItems(r.data.items || [])); }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-10">
      <h1 className="font-head text-3xl font-bold text-slate-900 mb-2">Sektöre Göre Keşfedin</h1>
      <p className="text-slate-500 mb-8 max-w-2xl">
        Aynı ürün birden fazla sektörde görünebilir. Sektör bağlantıları ürünün kullanım rolünü belirtir;
        bir laboratuvar kimyasalının doğrudan gıda veya kozmetik üretimine katıldığı anlamına gelmez.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((s) => (
          <Link key={s.sektor_id} to={`/urunler?sektor=${s.sektor_id}`} data-testid={`sector-${s.sektor_id}`}
            className="group bg-white border border-slate-200 rounded-xl p-5 hover:border-teal-400 hover:shadow-md transition-all">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-slate-900 text-white flex items-center justify-center shrink-0">
                <Factory className="w-5 h-5" />
              </div>
              <div className="min-w-0">
                <div className="font-head font-semibold text-slate-900 group-hover:text-teal-700">{s.sektor_adi_tr}</div>
                {s.kapsam_notu && <p className="text-xs text-slate-500 mt-1 line-clamp-2">{s.kapsam_notu}</p>}
              </div>
              <ArrowRight className="w-4 h-4 text-slate-300 group-hover:text-teal-500 ml-auto shrink-0" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
